import {connect} from 'react-redux';
import {setNotificationAction} from '@pluto/notification/Redux/NotificationActions';
import MediaOrdersItemContainer from './MediaOrdersItemContainer';
import {
    setMediaOrderAction,
    resetMediaOrderAction,
    deleteMediaOrderItemAction,
    restoreMediaOrderItemAction,
    setMediaOrderItemSortedAction,
} from './Redux/MediaOrdersItemActions';
import {MediaOrdersItemStateType, WorkflowStateType} from '../MediaOrdersTypes';

interface State {
    mediaOrders: {mediaOrdersItem: MediaOrdersItemStateType};
    textEnums: {workflowState: WorkflowStateType};
}

export const mapState = (state: State) => {
    return {
        mediaOrdersItem: state.mediaOrders.mediaOrdersItem,
        workflowState: state.textEnums?.workflowState,
    };
};

export const mapDispatch = {
    setItem: setMediaOrderAction,
    setSorted: setMediaOrderItemSortedAction,
    resetItem: resetMediaOrderAction,
    setNotification: setNotificationAction,
    deleteItem: deleteMediaOrderItemAction,
    restoreItem: restoreMediaOrderItemAction,
};

export default connect(mapState, mapDispatch)(MediaOrdersItemContainer);
